var map = {
	"./address.svg": "44ff",
	"./altitude.svg": "8c09",
	"./amber-warning.svg": "b67e",
	"./avg-fuel-economy.svg": "1d99",
	"./brake-primary.svg": "f228",
	"./brake-secondary.svg": "0851",
	"./coolant-level.svg": "d4bb",
	"./coolant-temp-cool.svg": "f534",
	"./coolant-temp-hot.svg": "2000",
	"./coolant-temp-warm.svg": "3a8b",
	"./coolant-temp.svg": "cec6",
	"./datetime.svg": "70f2",
	"./device-status-activated.svg": "c6cb",
	"./device-status-not-activated.svg": "d56a",
	"./engine-hour.svg": "1049",
	"./engine-speed.svg": "1a8a",
	"./engine-status-amber.svg": "a23c",
	"./engine-status-red.svg": "b5fd",
	"./engine-status.svg": "ed9a",
	"./fleet-type.svg": "433d",
	"./fleet-vin.svg": "0c35",
	"./fuel-level.svg": "9de8",
	"./gyro.svg": "f543",
	"./ignition-off.svg": "022a",
	"./ignition-on.svg": "8a28",
	"./location.svg": "c411",
	"./magneto.svg": "5553",
	"./maintenance.svg": "fdad",
	"./malfunction-indicator-error.svg": "05b8",
	"./malfunction-indicator-off.svg": "eedc",
	"./malfunction-indicator-on.svg": "bffa",
	"./malfunction-indicator-unavailable.svg": "c0a9",
	"./odometer.svg": "8aa0",
	"./oil-pressure.svg": "96f0",
	"./organization-description.svg": "7a75",
	"./organization-timezone.svg": "8379",
	"./parking-brake-off.svg": "4bce",
	"./parking-brake-on.svg": "c51c",
	"./protect-lamp.svg": "aee8",
	"./rectangle-fill-black.svg": "a194",
	"./rectangle-fill-green.svg": "dde0",
	"./rectangle-fill-orange.svg": "3fc3",
	"./rectangle-fill-red.svg": "2696",
	"./rectangle-outline.svg": "aa76",
	"./red-stop-lamp-error.svg": "59e2",
	"./red-stop-lamp-off.svg": "27b0",
	"./red-stop-lamp-on.svg": "bebd",
	"./red-stop-lamp-unavailable.svg": "caf2",
	"./site-category.svg": "0ac0",
	"./trip-distance.svg": "ae80",
	"./trip-duration.svg": "72cc",
	"./trip-emission.svg": "d5f1",
	"./trip-fuel-coaching-0.svg": "5149",
	"./trip-fuel-coaching-1.svg": "4e59",
	"./trip-fuel-coaching-2.svg": "3860",
	"./trip-fuel-idle.svg": "e4ad",
	"./trip-fuel-operation.svg": "38b8",
	"./trip-hour-idle.svg": "8613",
	"./trip-hour-operation.svg": "2d10",
	"./vehicle-speed.svg": "2671"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";